import React from "react";
import { FormattedMessage } from "react-intl";

import CorneredCard from "components/CorneredCard";
import { PictureAsPdf } from "components/Icons/index";

const UserManuals = () => (
  <div className="tab2">
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/MijnCNB_gebruikershandleiding_Invoeren_leveringen.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_DELIVERIES_TITLE" />
      </a>
      <FormattedMessage id="USER_MANUALS_DELIVERIES_DESCRIPTION" tagName="p" />
    </CorneredCard>
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/MijnCNB_gebruikershandleiding_Rekeningoverzicht_en_BTW_en_omzetoverzicht_per_betaaldatum.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_STATEMENTS_TITLE" />
      </a>
      <FormattedMessage id="USER_MANUALS_STATEMENTS_DESCRIPTION" tagName="p" />
    </CorneredCard>
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_Rekeningoverzicht_naar_Excel_exporteren.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_EXCEL_TITLE" />
      </a>
      <FormattedMessage id="USER_MANUALS_EXCEL_DESCRIPTION" tagName="p" />
    </CorneredCard>
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_Wachtwoord_resetten.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_RESET_PASSWORD_TITLE" />
      </a>
      <FormattedMessage
        id="USER_MANUALS_RESET_PASSWORD_DESCRIPTION"
        tagName="p"
      />
    </CorneredCard>
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_Zuurnota_invoeren.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_ZURRNOTA_TITLE" />
      </a>
      <FormattedMessage id="USER_MANUALS_ZURRNOTA_DESCRIPTION" tagName="p" />
    </CorneredCard>
    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_Areaalopgaven_invoeren.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_AREAAL_TITLE" />
      </a>
      <FormattedMessage id="USER_MANUALS_AREAAL_DESCRIPTION" tagName="p" />
    </CorneredCard>

    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_Bedrijfsgegevens.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_BEDRIJFSGEGEVENS_TITLE" />
      </a>
      <FormattedMessage
        id="USER_MANUALS_BEDRIJFSGEGEVENS_DESCRIPTION"
        tagName="p"
      />
    </CorneredCard>

    <CorneredCard>
      <a
        className="title"
        target="_blank"
        href="/assets/files/Mijn_CNB_gebruikershandleiding_gebruikersbeheer.pdf"
      >
        <PictureAsPdf />
        <FormattedMessage id="USER_MANUALS_GEBRUIKERSBEHEER_TITLE" />
      </a>
      <FormattedMessage
        id="USER_MANUALS_GEBRUIKERSBEHEER_DESCRIPTION"
        tagName="p"
      />
    </CorneredCard>
  </div>
);

export default UserManuals;
